import AgendaIndex from 'Pages/Agenda';
import AddToCalendarPage from 'Pages/Agenda/AddToCalendarPage';

import AdminAgendaIndex from 'Pages/Admin/Agenda';
import AdminAgendaStore from 'Pages/Admin/Agenda/store';
import OldAgendaIndex from "Pages/Agenda/OldAgendaIndex";

export default [
	// Frontend
	{ path: '/agenda', component: AgendaIndex },
	//{ path: '/add-to-calendar/:item', component: AddToCalendarPage },

	// Admin
	{ path: '/admin/agenda', component: AdminAgendaIndex, guards: ['admin'] },
    { path: '/admin/agenda/store/:agenda?', component: AdminAgendaStore, guards: ['admin'] },
];
